module.exports = __webpack_public_path__ + "static/media/mob6.1cd6f53a.jpeg";